export class EditMemberDto {
  username: string
  displayName: string
  firstName: string
  lastName: string
  gender: string
  birthdate: string
  email: string
  contactNumber: string
  addressLine1: string
  addressLine2: string
  addressPostcode: string
  addressTownCity: string
  addressCountry: string
  locale: string = '' // locale used on the station
  displayLocale: string = '' // locale used on the platform

  emergencyContactName: string
  emergencyContactRelationship: string
  emergencyContactNumber: string
  clubRoleType: string
  avatarOriginalUrl: string
  avatar: object | null

  constructor (attributes?) {
    if (attributes) {
      this.username = attributes.username ? attributes.username.trim() : ''
      this.displayName = attributes.displayName ? attributes.displayName.trim() : ''
      this.firstName = attributes.firstName
      this.lastName = attributes.lastName
      this.email = attributes.email ? attributes.email.trim() : ''
      this.gender = attributes.gender
      this.birthdate = attributes.birthdate
      this.contactNumber = attributes.contactNumber
      this.addressLine1 = attributes.addressLine1
      this.addressLine2 = attributes.addressLine2
      this.addressPostcode = attributes.addressPostcode
      this.addressTownCity = attributes.addressTownCity
      this.addressCountry = attributes.addressCountry
      this.locale = attributes.locale || ''
      this.displayLocale = attributes.displayLocale || ''
      this.clubRoleType = attributes.clubRoleType || ''

      this.emergencyContactName = attributes.emergencyContactName
      this.emergencyContactRelationship = attributes.emergencyContactRelationship
      this.emergencyContactNumber = attributes.emergencyContactNumber
      this.avatarOriginalUrl = attributes.avatarOriginalUrl
      this.avatar = attributes.avatar
    }
  }
}

export class WizardEditMemberDto {
  username: string
  displayName: string
  contactNumber: string
  addressLine1: string
  addressLine2: string
  addressPostcode: string
  addressTownCity: string
  addressCountry: string
  locale: string = '' // locale used on the station
  displayLocale: string = '' // locale used on the platform

  emergencyPerson: string
  emergencyRelationship: string
  emergencyContactNumber: string
  avatarOriginalUrl: string
  avatar: object

  constructor (attributes) {
    this.username = attributes.username
    this.displayName = attributes.displayName
    this.contactNumber = attributes.contactNumber
    this.addressLine1 = attributes.addressLine1
    this.addressLine2 = attributes.addressLine2
    this.addressPostcode = attributes.addressPostcode
    this.addressTownCity = attributes.addressTownCity
    this.addressCountry = attributes.addressCountry
    this.locale = attributes.locale || ''
    this.displayLocale = attributes.displayLocale || ''

    this.emergencyPerson = attributes.emergencyPerson
    this.emergencyRelationship = attributes.emergencyRelationship
    this.emergencyContactNumber = attributes.emergencyContactNumber
    this.avatarOriginalUrl = attributes.avatarOriginalUrl
    this.avatar = attributes.avatar
  }
}
